ux-table-data-column-selection {
  display: none;
}
